



































































import { Vue, Component, Prop } from 'vue-property-decorator';

import TabGeneral from './tabs/TabGeneral.vue';
import TabDispositivos from '@/pantallas/Conecta/BajasCobranza/gridActions/tabs/TabDispositivos.vue';

@Component({
  components: {
    TabGeneral,
    TabDispositivos,
  },
})
export default class BajasCobranzaVerDetalle extends Vue {
  @Prop({ required: true, default: {} }) data!: any;
  dialog: boolean = true;
  tabs: number = 0;

  handleClose(): void {
    this.$emit('cerrar');
  }
}
